import React, { useState, useEffect, useRef } from "react";
import UserTable from "./userTable";
import { Link, useNavigate } from "react-router-dom";
import { IoMdAdd } from "react-icons/io";
import { FaPrint, FaClipboardCheck } from "react-icons/fa";
import SearchAndPrint from "./searchprint";
import Header from "../../header";
import Navvbar from "../../Navvbar";
import Sidebar from "../../../Sidebar";
import Swal from "sweetalert2";
import { getBadgeCode } from "./PrintBadges";
// import { Link, useNavigate } from "react-router-dom";
import "./users.css";

const Users = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentUserId, setCurrentUserId] = useState(null);
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [currentUserLabId, setCurrentUserLabId] = useState(null);

  // ===== ADD DROPDOWN STATE =====
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // ===== PAGINATION STATE =====
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  // Dropdown ke bahar click karne par band ho jaye
  useEffect(() => {
    const handleOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError(null);

      try {
        const userId = localStorage.getItem("userId");
        const userRole = localStorage.getItem("userRole");
        const userLabId = localStorage.getItem("userLabId");

        setCurrentUserId(userId);
        setCurrentUserRole(userRole);
        setCurrentUserLabId(userLabId);

        const res = await fetch("https://hms.backend.hiragroupcloud.com/api/auth/labusers", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });

        if (!res.ok) throw new Error(`Error: ${res.status}`);

        const data = await res.json();

        const normalizedUsers = Array.isArray(data.users)
          ? data.users.map((user) => ({
              id: user.userId || user._id,
              userId: user.userId || user._id,
              email: user.email || "",
              firstName: user.firstName || user.first_name || "",
              lastName: user.lastName || user.last_name || "",
              role: user.role || "User",
              labId: user.labId || "",
              addedBy: user.addedBy || null,
              isSuperAdmin: user.isSuperAdmin || false,
              first_name: user.first_name || user.firstName,
              last_name: user.last_name || user.lastName,
            }))
          : [];

        setUsers(normalizedUsers);
      } catch (err) {
        setError(err.message);
        Swal.fire("Error", err.message, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Reset to page 1 when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handleDeleteUser = async (userId) => {
    try {
      const res = await fetch(
        `https://hms.backend.hiragroupcloud.com/api/auth/delete-users/${userId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `Error: ${res.status}`);
      }

      setUsers((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "User has been successfully deleted.",
        timer: 2000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
        background: "#d4edda",
        iconColor: "#28a745",
        customClass: {
          popup: "border border-success",
        },
      });
    } catch (err) {
      Swal.fire(
        "Error",
        err.message || "Failed to delete user",
        "error"
      );
    }
  };

  // ===== FILTERED USERS =====
  const filteredUsers = users.filter((user) =>
    `${user.email} ${user.firstName} ${user.lastName}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // ===== DROPDOWN ACTIONS =====
 const handlePrintBadges = () => {
  setMenuOpen(false);
  navigate("/PrintBadges");
};

  const handleScanning = () => {
  setMenuOpen(false);
  navigate("/ScanningAssigning");
};

  const handleExportExcel = () => {
    setMenuOpen(false);
    const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const rows = [
      ["Name", "Email", "Role", "Badge Code"],
      ...filteredUsers.map((u) => [
        `${u.firstName} ${u.lastName}`.trim(),
        u.email,
        u.role,
        getBadgeCode(u.id),
      ]),
    ];
    const csv = "\uFEFF" + rows.map((r) => r.map(esc).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "users.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  // ===== PAGINATION CALCULATIONS =====
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  // Ensure currentPage doesn't exceed totalPages after deletion
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [filteredUsers.length, currentPage, totalPages]);

  // ===== PAGINATION HANDLERS =====
  const handleFirstPage = () => setCurrentPage(1);
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const handleLastPage = () => setCurrentPage(totalPages);

  // Generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  const showAddButton = currentUserRole === "Admin";

  return (
    <>
      <Header />
      <Navvbar />
      <br />

      <div className="users-wrapper">
        <div className="users-row">

          {/* ================= SIDEBAR ================= */}
          <div className="users-sidebar-col">
            <Sidebar />
          </div>

          {/* ================= MAIN CONTENT ================= */}
          <div className="users-main-content-col">
            <h1 className="users-main-heading">Users</h1>

            <div className="content-box">

              {/* Header Controls */}
              <div className="header-controls">
                <SearchAndPrint setSearchTerm={setSearchTerm} />

                {showAddButton && (
                  <div className="add-button-container" ref={menuRef}>
                    <Link to="/AddNewUser" className="add-button-link">
                      <IoMdAdd style={{ fontSize: "14px" }} />
                      Add
                    </Link>
                    <button
                      type="button"
                      className="add-button-dropdown"
                      onClick={() => setMenuOpen((o) => !o)}
                    >
                      ▼
                    </button>

                    {menuOpen && (
                      <div className="add-dropdown-menu">
                        <button type="button" onClick={handlePrintBadges}>
                          <FaPrint /> Print Badges
                        </button>
                        <button type="button" onClick={handleScanning}>
                          <FaClipboardCheck /> Scanning &amp; Assigning
                        </button>
                        <button type="button" onClick={handleExportExcel}>
                          <FaClipboardCheck /> Export to Excel
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Showing Entries Info - Top */}
              <div className="showing-entries">
                Showing {filteredUsers.length > 0 ? indexOfFirstUser + 1 : 0} to{" "}
                {Math.min(indexOfLastUser, filteredUsers.length)} of{" "}
                {filteredUsers.length} entries
              </div>

              {loading && (
                <div className="loading-container">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="loading-text">Loading users...</p>
                </div>
              )}

              {error && !loading && (
                <div className="alert alert-danger" role="alert">
                  Error: {error}
                </div>
              )}

              {/* Table */}
              {!loading && !error && (
                <UserTable
                  users={currentUsers}
                  onUserDeleted={handleDeleteUser}
                />
              )}

              {/* Bottom Pagination Bar */}
              <div className="pagination-container">
                <div style={{ whiteSpace: "nowrap" }}>
                  Showing {filteredUsers.length > 0 ? indexOfFirstUser + 1 : 0} to{" "}
                  {Math.min(indexOfLastUser, filteredUsers.length)} of{" "}
                  {filteredUsers.length} entries
                </div>

                <div className="pagination-controls">
                  <button onClick={handleFirstPage} disabled={currentPage === 1}>
                    First
                  </button>
                  <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                    Previous
                  </button>

                  {getPageNumbers().map((pageNum) => (
                    <button
                      key={pageNum}
                      className={currentPage === pageNum ? "active-page" : ""}
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  ))}

                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    Next
                  </button>
                  <button
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    Last
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;